import cx from 'classnames'
import PropTypes from 'prop-types'

import './styles.scss'

export function Paper ({
  children,
  rounded,
  circle,
  style,
  color,
  zDepth,
  noPadding,
  noBackground,
  noTopBorderRadius,
  noBorderRadius,
  className,
  ...other
}) {
  const paperClass = cx(className, {
    'nh-paper': true,
    rounded,
    circle,
    'no-padding': noPadding,
    'no-background': noBackground,
    'z-depth-0': zDepth === 0,
    'z-depth-1': zDepth === 1,
    'z-depth-2': zDepth === 2,
    'z-depth-3': zDepth === 3,
    'z-depth-4': zDepth === 4,
    'z-depth-5': zDepth === 5,
    'no-top-border-radius': noTopBorderRadius === true,
    'no-border-radius': noBorderRadius === true,
    'grey': color === 'grey'
  })

  return (
    <div
      {...other}
      className={paperClass}
      style={style}
    >
      {children}
    </div>
  )
}

Paper.propTypes = {
  children: PropTypes.node,
  rounded: PropTypes.bool,
  style: PropTypes.instanceOf(Object),
  color: PropTypes.oneOf([ 'grey' ]),
  zDepth: PropTypes.oneOf([ 0, 1, 2, 3, 4, 5 ])
}
